import connect from '../api/connect'
import Form from '../../types/api/form'
import Shipment from '../../types/api/shipment'
import Task, { FormReorderTaskDetails } from '../../types/api/task'
import { StrapiCreate } from '../../types/strapi/strapi'

type SelectedForm = Pick<Form, 'documentId' | 'num' | 'color' | 'colorName'>

export default function extractCreateFormReorderTaskArg(
    shipment: Shipment,
    description?: string,
    selectedForm?: SelectedForm
): StrapiCreate<Task> {
    const details: FormReorderTaskDetails = {
        type: 'Перезаказ форм',
        reason: 'breakage',
        stampId: shipment.stamp?.documentId,
    }

    if (selectedForm) {
        details.sourceFormIds = [selectedForm.documentId]
        details.forms = [
            {
                documentId: selectedForm.documentId,
                num: selectedForm.num,
                color: selectedForm.color,
                colorName: selectedForm.colorName,
            },
        ]
    }

    return {
        data: {
            type: 'Перезаказ форм',
            performer: connect(shipment.designer),
            originType: 'shipment',
            originId: shipment.documentId,
            shipment: connect(shipment),
            description,
            details,
            taskStatus: 'Новая',
        },
    }
}
